import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState } from "react";
import { useDispatch, useSelector } from "@root/store";
import { useTheme } from "@emotion/react";
import { TailSpin } from "react-loader-spinner";
import * as SS from "./styles";
import Tooltip from "@mui/material/Tooltip";
import { pathOr } from "ramda";
import { getDefaultTargetDocument, getPlayActionFromProject, getPlayActionFromTarget } from "./utils";
import { selectSelectedTarget } from "./selectors";
import { useSetConsole } from "@comp/console/context";
import { pauseCsound, resumePausedCsound } from "@comp/csound/actions";
import { saveAllFiles } from "@comp/projects/actions";
import { jsx as ___EmotionJSX } from "@emotion/react";
var PlayButton = function PlayButton(_ref) {
    var activeProjectUid = _ref.activeProjectUid, isOwner = _ref.isOwner;
    var setConsole = useSetConsole();
    var _useState = useState(false), _useState2 = _slicedToArray(_useState, 2), isLoading = _useState2[0], setIsLoading = _useState2[1];
    var theme = useTheme();
    var playActionDefault = useSelector(getPlayActionFromTarget(activeProjectUid));
    var playActionFallback = useSelector(getPlayActionFromProject(activeProjectUid));
    var csoundPlayState = useSelector(function (store) {
        return pathOr("stopped", ["csound", "status"], store);
    });
    var selectedTargetName = useSelector(selectSelectedTarget(activeProjectUid));
    var fallbackTargetDocument = useSelector(getDefaultTargetDocument(activeProjectUid));
    var dispatch = useDispatch();
    var tooltipText = !selectedTargetName && !fallbackTargetDocument ? "" : csoundPlayState === "playing" ? "pause playback" : csoundPlayState === "paused" ? "resume playback" : "run ".concat(selectedTargetName || fallbackTargetDocument.filename);
    var playAction = playActionDefault || playActionFallback;
    return csoundPlayState === "rendering" ? ___EmotionJSX(React.Fragment, null) : ___EmotionJSX(Tooltip, {
        title: isLoading ? "loading..." : tooltipText
    }, ___EmotionJSX("div", {
        css: SS.playButtonContainer,
        onClick: /*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1)
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!isLoading) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return");
                        case 2:
                            setIsLoading(true);
                            if (playAction) {
                                _context.next = 6;
                                break;
                            }
                            console.error("Don't know how to play this project");
                            return _context.abrupt("return");
                        case 6:
                            _context.t0 = csoundPlayState;
                            _context.next = _context.t0 === "playing" ? 9 : _context.t0 === "paused" ? 11 : _context.t0 === "stopped" ? 13 : _context.t0 === "error" ? 13 : _context.t0 === "initialized" ? 13 : 18;
                            break;
                        case 9:
                            dispatch(pauseCsound());
                            return _context.abrupt("break", 18);
                        case 11:
                            dispatch(resumePausedCsound());
                            return _context.abrupt("break", 18);
                        case 13:
                            if (isOwner) {
                                dispatch(saveAllFiles());
                            }
                            _context.t1 = playAction;
                            if (!_context.t1) {
                                _context.next = 18;
                                break;
                            }
                            _context.next = 18;
                            return playAction(dispatch, setConsole);
                        case 18:
                            setIsLoading(false);
                        case 19:
                        case "end":
                            return _context.stop();
                    }
            }, _callee);
        }))
    }, isLoading ? ___EmotionJSX(TailSpin, {
        css: SS.playButtonLoadingSpinner,
        color: theme.buttonIcon,
        height: 25,
        width: 25
    }) : ___EmotionJSX("button", {
        css: SS.playButtonStyle(["playing", "rendering"].includes(csoundPlayState))
    })));
};
export default PlayButton;
